export default () => ({
  user: null,
  error: null,
  idToken: null,
  accessToken: null,
  createApplicationFailed: false
})
